var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingIcon } from '@/icons';
export const Button = (_a) => {
    var { variant = 'primary', size = 'md', fullWidth = false, className = '', children, rightIcon, buttonRef, isLoading = false } = _a, props = __rest(_a, ["variant", "size", "fullWidth", "className", "children", "rightIcon", "buttonRef", "isLoading"]);
    const baseStyles = 'inline-flex items-center justify-center font-medium focus:outline-none transition-colors rounded-full';
    const variantStyles = {
        primary: 'bg-vjwPrimary text-white hover:bg-vjwPrimary hover:ring-1 focus:ring-1 focus:ring-vjwPrimary hover:ring-vjwPrimary disabled:opacity-50 disabled:cursor-not-allowed',
        secondary: 'bg-vjwSecondary text-vjwPrimary hover:bg-vjwSecondary hover:ring-1 focus:ring-1 focus:ring-vjwPrimary hover:ring-vjwPrimary',
        text: 'text-black',
        outline: 'text-vjwPrimary hover:ring-1 hover:bg-vjwSecondary focus:bg-vjwSecondary focus:ring-1 focus:ring-vjwPrimary hover:ring-vjwPrimary',
        dangerSecondary: 'bg-vjwDanger/20 text-vjwDanger hover:bg-vjwDanger/30',
        secondaryOutline: 'bg-vjwSecondary text-vjwPrimary hover:bg-vjwSecondary hover:ring-1 focus:ring-1 focus:ring-vjwPrimary hover:ring-vjwPrimary border border-vjwPrimary',
    };
    const sizeStyles = {
        sm: 'text-sm px-2 py-1',
        md: 'text-base px-4 py-2',
        lg: 'text-lg px-6 py-3',
    };
    const mergeClasses = (defaultClasses, customClasses) => {
        const defaultClassList = defaultClasses.split(' ');
        const customClassList = customClasses.split(' ');
        const filteredDefaultClasses = defaultClassList.filter((defaultClass) => !customClassList.some((customClass) => customClass.startsWith(defaultClass.split('-')[0])));
        return [...filteredDefaultClasses, ...customClassList].join(' ');
    };
    const combinedClasses = mergeClasses(`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${fullWidth ? 'w-full' : ''}`, className);
    return (_jsx("button", Object.assign({ className: combinedClasses, ref: buttonRef, type: 'button' }, props, { disabled: !!(props === null || props === void 0 ? void 0 : props.disabled) || isLoading, children: isLoading ? (_jsx(LoadingIcon, {})) : (_jsxs(_Fragment, { children: [rightIcon && _jsx("span", { className: 'mr-1', children: rightIcon }), children] })) })));
};
